import { render, staticRenderFns } from "./sub_new.vue?vue&type=template&id=5b0378b8&scoped=true"
import script from "./sub_new.vue?vue&type=script&lang=js"
export * from "./sub_new.vue?vue&type=script&lang=js"
import style0 from "./sub_new.vue?vue&type=style&index=0&id=5b0378b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0378b8",
  null
  
)

export default component.exports